import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  ContactPerson,
} from "../../../app/slices/contactPersonSlice";
import { Controller, useForm } from "react-hook-form";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ContactPersonForm = () => {
  const dispatch = useDispatch();
  const _ContactPerson = useSelector(
    (state) => state.contactPerson.contactPerson,
  );
  const _SearchBody = useSelector((state) => state.contactPerson.searchBody);
  const loading = useSelector(
    (state) => state.contactPerson.contactPerson.loading,
  );

  const isAdd = _ContactPerson.form.id ? false : true;

  const { control, handleSubmit, reset } = useForm({
    defaultValues: _ContactPerson.form,
  });

  useEffect(() => {
    reset(_ContactPerson.form);
  }, [_ContactPerson.form, reset]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(ContactPerson.create(data, _SearchBody));
    } else {
      dispatch(ContactPerson.update(data.id, data, _SearchBody));
    }
  };

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <Dialog
      open={_ContactPerson.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth
      maxWidth="sm"
      dir="rtl"
      onClose={handleDialog}
      aria-describedby="contact-person-dialog"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color="primary"
          gutterBottom
          component="div"
        >
          {isAdd ? "إضافة جهة اتصال" : "تعديل جهة اتصال"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState }) => (
                  <TextField
                    required
                    size="small"
                    label="الاسم"
                    fullWidth
                    error={!!fieldState.error}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="mobile_1"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState }) => (
                  <TextField
                    required
                    size="small"
                    label="الهاتف الأول"
                    fullWidth
                    error={!!fieldState.error}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="mobile_2"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    label="الهاتف الثاني (اختياري)"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="job_title"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    label="المسمى الوظيفي"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ContactPersonForm;
